<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-4.14,782.5l-5.36,20l20-5.36l-0.24-0.87c-1.8-6.49-7.03-11.72-13.52-13.52L-4.14,782.5z M-2.86,784.75
	c5.64,1.76,9.34,5.46,11.11,11.1l-15.17,4.07L-2.86,784.75z"/>
</svg>

</template>